import type { AreaPopulationThresholds, PopulationThreshold } from "@situate/contracts/runtime";
import type { ChartThresholdSeverity, MultiLineChartThreshold } from "@/shared/charts";
import { ALL_AREAS_FILTER_VALUE } from "@/features/deployment-dashboard/types";

function getThresholdSeverity(severity: PopulationThreshold["severity"]): ChartThresholdSeverity {
  switch (severity) {
    case "critical":
      return "long";
    case "medium":
    case "high":
      return "moderate";
    case "info":
    case "warning":
      return "normal";
  }
}

function mapThreshold(threshold: PopulationThreshold): MultiLineChartThreshold {
  return {
    value: threshold.value,
    label: threshold.name,
    severity: getThresholdSeverity(threshold.severity),
  };
}

/**
 * Selects the API-normalized threshold lines for one area. Thresholds are deliberately omitted
 * for All Areas because the chart displays a combined series and must not aggregate area limits.
 */
export function getPopulationTrendThresholds(
  areaId: string | typeof ALL_AREAS_FILTER_VALUE,
  thresholds: AreaPopulationThresholds | null | undefined
): MultiLineChartThreshold[] | undefined {
  if (areaId === ALL_AREAS_FILTER_VALUE || thresholds == null) return undefined;

  const areaThresholds = thresholds.areas.find((area) => area.area_id === areaId);
  return areaThresholds == null ? undefined : areaThresholds.thresholds.map(mapThreshold);
}
